import { createFileRoute } from '@tanstack/react-router'
import { usePageTitle } from '../../../features/page-title/pageTitle'
import { ProfilePage } from '../../../features/profile/ProfilePage.tsx'

export const Route = createFileRoute('/me/_settings/profile')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle('Profile')
  return <ProfilePage />
}
